/**
 * Amazon Fire TV CastingProvider — FOUNDATION + REQUIRES NATIVE RECEIVER.
 *
 * Separate from Chromecast and Roku. Fire TV cast from web requires a Fire TV
 * application that receives CastReceiverSession / control messages.
 * Do not treat Fire TV as Chromecast even when a device also speaks Cast.
 */

import { CastingCapabilityState } from "./CastingEvents";
import { CastPlatformReceiverRequirements } from "./CastReceiverContract";
import { createReceiverRequiredProvider } from "./createReceiverRequiredProvider";

export function createFireTVProvider(options) {
  var req = CastPlatformReceiverRequirements.firetv;
  return createReceiverRequiredProvider(
    {
      id: "firetv",
      displayName: "Amazon Fire TV",
      capabilityState: CastingCapabilityState.REQUIRES_RECEIVER_APP,
      reason: req.mechanism,
      receiverContract: {
        packageNameField: "fireTvPackageName",
        payload: {
          contentId: "string",
          mediaRef: "authorized playback URL / grant",
          title: "string",
          artwork: "string URL",
          position: "number seconds",
          sessionId: "string",
          actions: ["play", "pause", "seek", "stop", "setVolume", "load"],
        },
        fields: req.contractFields,
        auth: "existing StreamView / white-label auth — no unauthorized private URLs",
      },
    },
    options
  );
}

export default createFireTVProvider;
